import React from 'react';

import {Props} from './model';
import {useDeviceSize, DeviceSize} from '../../../../shared/theme/helpers';

import {useStyles} from '../../../../shared/hooks/styles';
import {View} from 'react-native';
import {useTheme} from '../../../../shared/theme';
import {Text} from '../../../../shared/components/text';

export default (props: Props) => {
  const deviceSize = useDeviceSize();
  const theme = useTheme();
  const styles = useStyles(({isDesktop}) => {
    return {
      text: {
        color: theme.color.primaryColor,
        marginTop: isDesktop ? 32 : 0,
        marginBottom: 32,
      },
      mobileText: {
        color: theme.color.gray600,
        paddingVertical: 12,
        marginHorizontal: 16,
        textAlign: 'center',
      },
      mobileContainer: {
        marginHorizontal: -16,
        backgroundColor: theme.color.blue200,
      },
    };
  });

  if (deviceSize === DeviceSize.desktop) {
    return (
      <Text testID='desktop-hello-name-id' type='h4' style={styles.text}>
        Здравствуйте, {props.name}!
      </Text>
    );
  }
  return (
    <View style={styles.mobileContainer}>
      <Text testID='mobile-hello-name-id' type='h6' style={styles.mobileText}>
        Здравствуйте, {props.name}!
      </Text>
    </View>
  );
};
